import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_47() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter August 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            EFRAG Proposes ESG Reporting Standards for Large Non-EU Groups
            Operating in Europe.
          </title>
          <meta
            name="description"
            content="EFRAG has proposed dedicated European Sustainability Reporting Standards for large non-EU corporate groups with significant commercial operations in the European Union."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          EFRAG Proposes ESG Reporting Standards for Large Non-EU Groups
          Operating in Europe.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/August_2026_1.webp")}
            alt="EFRAG Proposes ESG Reporting Standards for Large Non-EU Groups Operating in Europe."
            loading="lazy"
          />
        </figure>
        <p>
          EFRAG has proposed dedicated European Sustainability Reporting
          Standards for large non-EU corporate groups with significant
          commercial operations in the European Union. The framework targets
          third-country parent groups operating through qualifying EU
          subsidiaries or branches and would require reporting on material
          impacts on people and the environment. It covers climate change,
          pollution, water, biodiversity, circular economy, workforce, affected
          communities, consumers and business conduct.
        </p>
        <p>
          Under the draft framework, reporting obligations would apply where a
          third-country parent group generates more than €450 million in EU net
          turnover in each of the previous two consecutive financial years and
          has an EU subsidiary or branch exceeding €200 million in net turnover
          in the preceding year. Sustainability reports would generally be
          prepared at the ultimate parent or consolidated group level and
          accompanied by an assurance opinion.
        </p>
        <p>
          The proposed standards emphasise impact materiality and extend
          reporting to material impacts connected with upstream and downstream
          value chains. For non-climate matters, qualifying groups may, subject
          to specified conditions, limit disclosures to identifiable EU-related
          impacts, offering a defined reporting boundary for internationally
          diversified businesses.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The proposed framework could reshape how non-EU groups structure
            sustainability governance across European operations. Industries
            with complex supply chains, particularly manufacturing, energy,
            chemicals, consumer goods and financial services, may need more
            granular impact-mapping and traceable value-chain data. This could
            gradually embed EU-specific materiality considerations into global
            reporting architectures, influencing data controls, supplier
            engagement, assurance readiness and sustainability decision-making
            across multinational groups.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Singapore Sets Out ISSB-Aligned Sustainability Disclosure Standards
          Under Climate-First Reporting Framework.
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/August_2026_2.webp")}
              alt="Singapore Sets Out ISSB-Aligned Sustainability Disclosure Standards Under Climate-First Reporting Framework."
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          Singapore has proposed Singapore Sustainability Disclosure Standards
          (SDS), providing a domestic reporting framework aligned with the
          International Sustainability Standards Board’s IFRS S1 and IFRS S2.
          The proposed SFRS S1 addresses general sustainability-related
          financial disclosures, while SFRS S2 focuses specifically on
          climate-related information. Under Singapore’s climate-first approach,
          SFRS S1 would initially remain voluntary, while climate-related
          disclosures form the mandatory component. This structure reflects the
          broader international movement towards consistent, decision-useful
          sustainability information covering governance, strategy, risk
          management, metrics and targets.
        </p>
        <p>
          The implementation framework differentiates requirements according to
          company size and market profile. All SGX-listed companies are already
          required to disclose Scope 1 and Scope 2 greenhouse gas emissions.
          Straits Times Index constituents, comprising 30 major listed
          companies, are also subject to broader ISSB-based climate disclosures
          and Scope 3 emissions reporting. For non-STI listed companies with
          market capitalisation of at least S$1 billion, other ISSB-based
          climate disclosures will apply from FY2028, while listed companies
          below that threshold will follow from FY2030. Scope 3 reporting for
          these non-STI companies remains voluntary until further notice.
        </p>
        <p>
          Large non-listed companies meeting the prescribed revenue and asset
          thresholds will come within the climate-reporting regime from FY2030,
          subject to applicable exemptions, while Scope 3 disclosure remains
          voluntary. The framework also introduces external limited assurance
          over Scope 1 and Scope 2 emissions from FY2029 for listed companies
          and FY2032 for large non-listed companies. Assurance providers must
          meet specified registration or accreditation requirements.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Singapore’s climate-first model signals a shift from sustainability
            reporting as a disclosure exercise towards financial-grade climate
            information. The phased treatment of Scope 3 emissions recognises
            persistent value-chain data constraints, while mandatory assurance
            introduces greater discipline around emissions controls and
            reporting processes. For companies, the deeper implication is the
            growing convergence of climate governance, enterprise risk,
            financial reporting and internal control frameworks.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          France Sets Updated National Low-Carbon Strategy for 2050 Climate
          Targets.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/August_2026_3.webp")}
            alt="France Sets Updated National Low-Carbon Strategy for 2050 Climate Targets."
            loading="lazy"
          />
        </figure>
        <p>
          France has adopted an updated National Low-Carbon Strategy, setting
          out its policy framework for reaching carbon neutrality by 2050. The
          strategy establishes sector-specific carbon budgets and targets a 50%
          reduction in territorial greenhouse gas emissions by 2030 compared
          with 1990 levels. It covers transport, buildings, industry,
          agriculture, energy production and waste management.
        </p>
        <p>
          The strategy also addresses France’s consumption-based carbon
          footprint, including emissions associated with imported goods and
          services. The government aims to reduce this footprint by 71% to 79%
          by 2050 compared with 2010 levels, equivalent to approximately 2.3–3.1
          tonnes of CO₂ equivalent per person. Territorial emissions have
          declined by nearly 300 million tonnes of CO₂ equivalent over the past
          three decades.
        </p>
        <p>
          Policy measures under the framework include industrial
          decarbonisation, energy efficiency, building renovation,
          lower-emission transport and management of natural carbon sinks.
          Meeting the 2030 target will require average annual emissions
          reductions of around 5%, alongside sector-level monitoring and
          periodic assessment of progress against established carbon budgets.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            France’s low-carbon strategy shifts carbon from an environmental
            externality into a structural economic variable shaping capital
            allocation, industrial margins and asset valuation. Sectoral carbon
            budgets will influence investment cycles, procurement economics and
            the cost structure of energy-intensive industries. For businesses,
            competitiveness will increasingly depend on carbon productivity,
            supply-chain emissions and transition-adjusted returns, while the
            economy will see capital progressively redirected toward
            infrastructure and industrial systems aligned with long-term
            emissions constraints.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          South Korea Expands Corporate Sustainability Reporting with Phased
          Compliance Requirements
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/August_2026_4.webp")}
            alt="South Korea Expands Corporate Sustainability Reporting with Phased Compliance Requirements"
            loading="lazy"
          />
        </figure>
        <p>
          South Korea’s sustainability disclosure roadmap will require
          KOSPI-listed companies with consolidated assets of at least KRW10
          trillion to report from 2028 using FY2027 data. The threshold falls to
          KRW5 trillion in 2029, bringing an estimated 291 companies, including
          affiliates, into scope and 3,171 the following year. Authorities may
          consider a KRW2 trillion threshold from 2030.
        </p>
        <p>
          Companies will report through business reports under the Financial
          Investment Services and Capital Markets Act, using Korea
          Sustainability Standards Board requirements aligned with IFRS S1 and
          S2. Disclosures focus on material sustainability-related financial
          information and climate risks and opportunities, covering governance,
          strategy, risk management, metrics and targets. In the first reporting
          year, groups may exclude affiliates whose assets and sales are each
          below 10% of consolidated totals.
        </p>
        <p>
          Third-party verification becomes mandatory from 2030, with assurance
          rules under development. Scope 3 emissions receive a three-year
          deferral, starting in 2031 for the largest cohort and 2032 for the
          KRW5 trillion cohort. Government support includes guidance for 15
          export industries and 1,000 Life Cycle Inventory datasets by 2028.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            From an ESG governance perspective, Korea’s phased regime signals a
            shift from narrative sustainability reporting toward controlled,
            financially connected disclosure. The real test will be whether
            companies can embed climate-related assumptions, value-chain
            emissions and material sustainability risks within existing
            financial reporting architecture. As assurance requirements mature,
            data lineage, estimation methodologies and internal controls will
            become increasingly important. This could progressively reposition
            sustainability information from a reporting output to an auditable
            component of corporate decision-making.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          ECB Broadens Climate-Risk Integration Across Corporate Loan Collateral
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/August_2026_5.webp")}
            alt="ECB Broadens Climate-Risk Integration Across Corporate Loan Collateral"
            loading="lazy"
          />
        </figure>

        <p>
          The European Central Bank is extending climate-risk adjustments in the
          Eurosystem collateral framework to certain eligible credit claims
          against non-financial corporations. The measure, expected from
          end-2027 at the earliest, builds on climate factors already applied to
          qualifying corporate bonds since 15 June 2026. It introduces an
          additional valuation reduction of up to 5% for collateral exposed to
          transition-related uncertainty.
        </p>
        <p>
          For corporate borrowers, climate performance may increasingly
          influence how banks assess the collateral value of loans used in
          Eurosystem refinancing. The methodology considers a sector-level
          stressor, the debtor’s exposure to transition uncertainty and the
          loan’s residual maturity. For corporate bonds, exposure assessments
          already incorporate greenhouse-gas emissions, decarbonisation targets
          and the quality of climate-related disclosures, indicating the growing
          importance of consistent, decision-useful climate data.
        </p>
        <p>
          Companies, particularly in carbon-intensive sectors, should therefore
          maintain credible emissions inventories, measurable transition targets
          and robust climate disclosures that can support lender due diligence.
          Where debtor-level information is unavailable, the Eurosystem may use
          sector-level or alternative data, while climate-factor values will be
          updated annually to reflect newer evidence.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            The ECB’s expanded climate-risk factors will encourage banks to
            integrate transition risk more systematically into collateral
            valuation, credit assessment and lending decisions. Banks financing
            carbon-intensive companies may face higher collateral haircuts,
            affecting borrowing capacity and liquidity management. This will
            increase the importance of collecting reliable emissions,
            transition-plan and climate-disclosure data from corporate clients.
            Banks may consequently strengthen climate-risk due diligence,
            portfolio monitoring and engagement with borrowers to maintain
            collateral quality and refinancing efficiency.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_47;
